import request from "@/request/request";
import store from "@/store";

//公共参数

//更多游戏-推荐标签-页面数据
export const reqRecommend = () => {
  let dataObj = store.state.public_param;
  // console.log("reqRecommend", dataObj)
  return request.post("/api/v1/index/index", dataObj);
}


//更多游戏-休闲游戏-页面数据
export const reqCasualData = () => {
  let dataObj = store.state.public_param;
  // console.log("reqCasualData", dataObj)
  return request.post("/api/v1/index/arder", dataObj);
}

//更多游戏-H5标签-页面数据
export const reqH5Data = (cateId) => {
  const dataObj = store.state.public_param;
  let data = { "cate_id": cateId, ...dataObj };
  return request.post("/api/v1/index/h5", data);
}

//更多游戏-排行榜标签-页面数据
export const reqRankData = (typeId) => {
  const dataObj = store.state.public_param;
  let data = { "type": typeId, ...dataObj }
  console.log("reqRankData", data)
  return request.post("/api/v1/index/rank", data);
}

//更多游戏-排行榜标签-投票给主播
export const reqRankVote = (anchor_id, add_num) => {
  const dataObj = store.state.public_param;
  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "anchor_id": anchor_id,
    "add_num": add_num
  }
  // console.log("reqRankVote", argData)
  return request.post("/api/v1/user/do-poll", argData);
}

//更多游戏-手游标签-页面数据
export const reqHandTourData = (cateId) => {
  const dataObj = store.state.public_param;

  let data = { "cate_id": cateId, ...dataObj }

  // console.log("reqHandTourData", data)
  return request.post("/api/v1/index/mobile-game", data);
}


//更多游戏-精彩活动标签-页面数据
export const reqWActivityData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
  }
  // console.log("reqRankVote", argData)
  return request.post("/api/v1/index/activity", argData);
}

//签到页面-日历数据
export const reqSignData = () => {
  const dataObj = store.state.public_param;

  let argData = { "day": "0" }
  let data = Object.assign({}, argData, dataObj)
  // console.log("reqSignData", data)
  return request.post("/api/v1/user/sign-index", data)
}

//签到页面-签到功能
export const reqDoSign = (day) => {
  const dataObj = store.state.public_param;

  let argData = { "day": day }
  let data = Object.assign({}, argData, dataObj)
  // console.log("reqDoSign", data)
  return request.post("/api/v1/user/do-sign", data)
}

//消息页面-列表数据
export const reqMessageData = (typeId) => {
  const dataObj = store.state.public_param;

  let argData = { "type": typeId }
  let data = Object.assign({}, argData, dataObj)
  // console.log("reqMessageData", data)
  return request.post("/api/v1/notice/list", data)
}

//消息页面-详情数据
export const reqMessageDetail = (msgId) => {
  const dataObj = store.state.public_param;

  let argData = { "id": msgId }
  let data = Object.assign({}, argData, dataObj)
  return request.post("/api/v1/notice/detail", data)
}

//搜索页面-热门搜索数据
export const reqHotSearchData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
  }
  // console.log("reqHotSearchData", argData)
  return request.post("/api/v1/game/hot-search", argData);
}

//搜索页面-热门分类数据
export const reqHotCateData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
  }
  // console.log("reqHotCateData", argData)
  return request.post("/api/v1/game/hot-cate", argData);
}


//搜索页面-关键字搜索数据
export const reqKeySearchData = (keyWord) => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "keyword": keyWord,
  }
  // console.log("reqKeySearchData", argData)
  return request.post("/api/v1/game/do-search", argData);
}

//首页title
export const reqHomeTitleData = () => {
  const dataObj = store.state.public_param;
  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,

  }
  return request.post("/api/v1/index/nav", argData);
}

//首页弹框和红点
export const reqHomePopupData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,

  }
  // console.log("reqHomePopupData", argData)
  return request.post("/api/v1/index/initialize", argData);
}

export const getNewManPackData = () => {
  return request.post("/api/v1/invite/prop-up-draw", {});
}

//vip弹框领取福利
export const reqVipGetTicketData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,

  }
  // console.log("reqVipGetTicketData", argData)
  return request.post("/api/v1/vip/draw", argData);
}

//猜你喜欢
export const reqYourLikeData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
  }
  // console.log("reqYourLikeData", argData)
  return request.post("/api/v1/game/guess", argData);
}
//历史活动
export const reqHistoryActivityData = () => {
  const dataObj = store.state.public_param;
  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
  }
  return request.post("/api/v1/task/history-hot-act", argData);
}
//热门活动
export const reqHotActivityData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
  }
  // console.log("reqHotActivityData", argData)
  return request.post("/api/v1/task/hot-act", argData);
}
//主播历史排行
export const reqHistoryRankData = (month) => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "month": month,
  }
  return request.post("/api/v1/anchor/history-rank", argData);
}

//热门活动详情
export const reqHotActivityDetail = (actID) => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "id": actID
  }
  // console.log("reqHotActivityDetail", argData)
  return request.post("/api/v1/task/hot-act-detail", argData);
}

//热门活动评论列表
export const reqActDetailComment = (actID, pageIndex, per_page) => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "target_id": actID,
    "module": "3",//评论模块 1-游戏详情 2-游戏攻略 3-热门活动
    "page": pageIndex, //当前页
    "per_page": per_page, //每页多少条记录
  }
  // console.log("reqActDetailComment", argData)
  return request.post("/api/v1/comment/strategy-comment-list", argData);
}


//新人任务
export const reqNewPersonTaskData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,

  }
  // console.log("reqNewPersonTaskData", argData)
  return request.post("/api/v1/task/new", argData);
}

//领取任务奖励
export const reqToGetAward = (taskID) => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "id": taskID,
  }
  // console.log("reqToGetAward", argData)
  return request.post("/api/v1/task/draw", argData);
}
//悬赏任务
export const reqTaskCenterData = () => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
  }
  // console.log("reqTaskCenterData", argData)
  return request.post("/api/v1/task/center", argData);
}
//任务详情
export const reqTaskDetailData = (taskID) => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "id": taskID,
  }
  // console.log("reqTaskDetailData", argData)
  return request.post("/api/v1/task/center-detail", argData);
}

//参与任务
export const reqToJoinTask = (taskID) => {
  const dataObj = store.state.public_param;

  let argData = {
    "access_token": dataObj.access_token,
    "time": dataObj.time,
    "sign": dataObj.sign,
    "id": taskID,
  }
  console.log("reqToJoinTask", argData)
  return request.post("/api/v1/task/partake", argData);
}
